import { m } from "../../paraglide/messages";
import { isTruthy } from "../../utils/isTruthy";
import { TooltipInfoIcon } from "../Tooltip/TooltipInfoIcon";

import { AnalyticCard } from "./AnalyticCard";

export function MetricCardEmpty({
  title,
  tooltip,
}: {
  title: string;
  tooltip?: string;
}) {
  return (
    <AnalyticCard dataTestId="metric-card-empty" fullHeight title="">
      <div className="flex flex-col gap-0 justify-between items-start w-full h-full min-w-0">
        <div className="flex flex-col gap-0 w-full min-w-0">
          <div className="flex gap-2 items-start min-w-0 w-full">
            <p
              className="body-base-medium flex-1 min-w-0 break-words"
              data-testid="metric-card-empty-title"
            >
              {title}
            </p>
            {isTruthy(tooltip) && <TooltipInfoIcon content={tooltip} />}
          </div>
          <p className="heading-4 text-text/secondary truncate w-full">-</p>
        </div>
        <div className="flex gap-1 items-center pt-4 body-small-regular text-text/disabled truncate w-full">
          {m.analytics_noPeriodToCompare()}
        </div>
      </div>
    </AnalyticCard>
  );
}
